/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ITabViewProps } from '@msdyn365-commerce-modules/tab/src/modules/tab/./tab';
import { _getViewPort } from '../../../utilities/get-viewport';

const tabView: React.FC<ITabViewProps> = props => {
    const { heading, TabContainer, tabHeaders, tabContents } = props;
    if (!props.heading && !props.tabHeaders && !props.tabContents) {
        props.context.telemetry.error('Tab content is empty, module wont render');
        return null;
    }
    // VSI Customization - Display dropdown on mobile view
    const viewPort = _getViewPort(props.context);
    const isMobile = viewPort === 'md' || viewPort === 'sm' || viewPort === 'xs';
    const tabs = tabHeaders as React.ReactNode[];
    const onOptionChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        event.persist();
        const { value } = event.target;
        const el = document.querySelector(`.${value}`) as HTMLOptionElement;
        el && el.click();
    };
    const mobileTabHeaders = (
        <select onChange={onOptionChange}>
            {tabs.map((item, i) => {
                const itemEl = item as JSX.Element;
                return (
                    <option
                        key={i}
                        className={`tab-item-${i}`}
                        value={`tab-item-${i}`}
                        tabIndex={itemEl.props.tabIndex}
                        aria-controls={itemEl.props['aria-controls']}
                        onClick={itemEl.props.onClick}
                        selected={itemEl.props['aria-selected']}
                    >
                        {itemEl}
                    </option>
                );
            })}
        </select>
    );
    // VSI Customization End
    return (
        <Module {...TabContainer}>
            <Node {...props.headerSection}>{heading}</Node>
            <Node {...props.tabsSection}>{isMobile ? mobileTabHeaders : tabHeaders}</Node>
            <Node {...props.tabItemContainer}>{tabContents}</Node>
        </Module>
    );
};

export default tabView;
